import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../alert-dialog/alert-dialog";
import { useState } from "react";
import { Input } from "../input/Input";
import { Trash2 } from "lucide-react";

const SafeConfirmDialog = ({
  isOpen,
  setIsOpen,
  description,
  confirmationHandler,
}) => {
  const [isDisabled, setIsDisabled] = useState(true);

  const onChangeHandler = (changeEvent) => {
    setIsDisabled("Delete" !== changeEvent.target.value);
  };

  const onConfirmationHandler = () => {
    setIsDisabled(true);
    confirmationHandler();
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <div className="flex flex-row">Delete confirmation</div>
          </AlertDialogTitle>
          <AlertDialogDescription>
            If you are sure you want to proceed with the deletion of{" "}
            <b>{description}</b>, please continue below.
            <br />
            <br />
            This operation is irreversible and will result in a complete
            deletion of all the data associated with the resource
            <br />
            <br />
            Type <b>Delete</b> below to confirm delete.
            <br />
            <br />
            <div className="relative ml-auto flex-1 md:grow-0">
              <Trash2 className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                type="search"
                placeholder="Delete"
                className="w-full rounded-lg bg-background pl-8 md:w-[200px] lg:w-full"
                onChange={onChangeHandler}
              />
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setIsDisabled(true)}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isDisabled}
            onClick={onConfirmationHandler}
            className="bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SafeConfirmDialog;
